module.exports = __webpack_public_path__ + "media/file_icons/default-0d78af41.png";